import axiosRestClient from "axios-rest-client"

const api = axiosRestClient({
  baseUrl: "/", // this is required
  // see axios for other configuration options
})

const service = axiosRestClient({
  baseUrl: "http://192.168.1.201:40001/mock/", // this is required
  // see axios for other configuration options
})

const request = axiosRestClient({
  // baseUrl: "http://192.168.1.117:5000/", 
  baseUrl: "/api",
  // baseUrl: "http://192.168.1.106:5000/",
})

// Create multiple resources endpoints
// api.endpoints({
//     users: 'users',           // /users endpoint
//     posts: 'post-resources'  // /post-resources endpoint
//   })

// api.endpoint('json')   // Create /users endpoint, 创建资源
// api.endpoint('testjson')
api.endpoints({
  mapJson: "mapJson",
}) // Create /users endpoint, 创建资源

service.endpoints({
  api: "11"
})

request.endpoints({
  categories: 'categories',
  information: 'information',
  region_information: 'region_information',
  regions: 'regions',
  mapSummarize: 'region_information/summarize',
  wordClouding: 'region_information/word_clouding',
  reportGenerate: 'reports/generate',
  domains_id: 'domains'
})

// request.endpoints({
//   api: 
// })

/**
 * 调用例子
 * 参考网址：https://www.npmjs.com/package/axios-rest-client
 */
//  api.json.all()               // GET /users
//  api.json.find(1)             // Get /users/1
//  api.json.create(data)        // POST /users, body=data
//  api.json.update(1, data)     // PUT /users/1, body=data
//  api.json.delete(1)           // DELETE /users/1

export {api, service, request}
